import React, {Component, Fragment, useEffect, useState} from "react";
import axios from "axios";
import {
    Badge,
    Button,
    Card,
    CardTitle,
    Carousel,
    CarouselControl,
    CarouselIndicators,
    CarouselItem, Table
} from "reactstrap";
import { Helmet } from 'react-helmet';
import getImage from "../GetImage";
import {Assortment} from "./Assortment";
import OrderModal from "./OrderModal";
import {useParams} from "react-router-dom";

export default class ProductPage extends Component
{
    constructor(props) {
        super(props);

        this.state = {index:0, animating:false, product:this.props.product, orderModalOpen:false}
        this.nameConverter = {
            box:"Что в коробке",
            color:"Цветовая палитра",
            chssis:"Тип шасси и рамы",
            weight:"Вес с упаковкой, кг",
            volume:"Объем в упаковке, м3",
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.product !== this.props.product )
        {
            this.setState({product:this.props.product, index:0})
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
    }

    getTable()
    {
        if(this.state.product == null)
            return (<p>Loading</p>)
        let index = 0;
        let params = []
        for (let i in this.state.product){
            if( index >=6 && index <=10 && this.state.product[i] != null)
            {
                params.push(<Fragment key = {index}>
                    <tr>
                    <th scope="row">
                        {this.nameConverter[i]}
                    </th>
                    <td>
                        {this.state.product[i]}
                    </td>
                    </tr>
                </Fragment>)
            }
            index+=1;
        }
        return(
            <Table className="stat-table">
                <tbody>
                {params}
                </tbody>
            </Table>);
    }

    getBuyButton()
    {
        let price = this.state.product.price === this.state.product.calculatedPrice?(<p>{this.state.product.calculatedPrice}руб./шт</p>):(
            <><p className="text-muted"><s>{this.state.product.price} руб./шт</s></p>
            <p>{this.state.product.calculatedPrice} руб./шт</p></>
        )
        let badge = null;
        if(this.state.product.price !== this.state.product.calculatedPrice)
            badge = (<Badge className="w-25 mb-2" color="danger">
                {100 - Math.round(this.state.product.calculatedPrice/this.state.product.price*100)}%
            </Badge>)
        return (<Card className="price-card">
            {badge}
            <CardTitle style={{fontSize:"1.5em"}} >
                {price}
            </CardTitle>
            <Button color="success" onClick={() => this.setState({orderModalOpen:true})}>Оформить</Button>
            </Card>)
    }

    getCarousel()
    {
        const activeIndex = this.state.index;
        const animating = this.state.animating;

        let items = []
        for (let i = 0; i < this.state.product.countImages; i++)
            items.push(getImage(this.state.product.article, i))
        const next = () => {
            if (animating) return;
            const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
            this.setState({index: nextIndex});
        };

        const previous = () => {
            if (animating) return;
            const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
            this.setState({index: nextIndex});
        };

        const goToIndex = (newIndex) => {
            if (animating) return;
            this.setState({index: newIndex});
        };

        const slides = items.map((item, index) => {
            return (
                <CarouselItem
                    key = {index}
                    className="carousel-item"
                    tag="div"
                    onExiting={() => this.setState({animating: true})}
                    onExited={() => this.setState({animating: false})}
                >
                    <img className="carousel-image" src={item} alt={this.state.product.name} loading="lazy"/>
                </CarouselItem>
            );
        });

        return (
            <div className="carousel-div"
                 onTouchStart={(e) => { this._touchX = e.touches[0].clientX }}
                 onTouchEnd={(e) => {
                     const diff = this._touchX - e.changedTouches[0].clientX;
                     if (Math.abs(diff) > 50) {
                         diff > 0 ? next() : previous();
                     }
                 }}>
                <Carousel activeIndex={activeIndex} next={next} previous={previous} dark fade>
                    <CarouselIndicators
                        activeIndex={activeIndex}
                        onClickHandler={goToIndex}
                     items={items}/>
                    {slides}
                    <CarouselControl
                        direction="prev"
                        directionText="Предыдущая"
                        onClickHandler={previous}
                    />
                    <CarouselControl
                        direction="next"
                        directionText="Следующая"
                        onClickHandler={next}
                    />
                </Carousel>
            </div>
        );
    }
    render() {
        if(this.state.product != null)
            return(
                <div >
                    <Helmet>
                        <title>{this.state.product.name} | iCandy</title>
                        <meta name="description" content={this.state.product.fullName} />
                        <meta property="og:title" content={`${this.state.product.name} | iCandy`} />
                        <meta property="og:description" content={this.state.product.fullName} />
                        <meta property="og:image" content={`/product/image/${this.state.product.article}/0`} />
                        <meta property="og:type" content="product" />
                    </Helmet>
                    <h1 className='m-3 ms-5'>{this.state.product.name}</h1>
                    <div className="product-container">
                        {this.getCarousel()}
                        <div className="m-3 flex-grow-1">
                            <p><b>Код товара</b> - {this.state.product.article}</p>
                            <p><b>Полное наименование</b> - {this.state.product.fullName}</p>
                            <p><b>Коллекция</b> - {this.state.product.collection}</p>
                            <h2>Характеристики</h2>
                            {this.getTable()}
                        </div>
                        {this.getBuyButton()}
                    </div>

                    <div className="m-5">
                        <h2 >Похожие товары</h2>
                        <Assortment collection={this.state.product.collection} type={this.state.product.type} excludeId={this.state.product.id} limit={8}/>
                    </div>

                    <div className="sticky-buy-bar">
                        <span className="sticky-buy-price">{this.state.product.calculatedPrice} ₽</span>
                        <Button color="success" onClick={() => this.setState({orderModalOpen:true})}>Оформить</Button>
                    </div>

                    <OrderModal
                        open={this.state.orderModalOpen}
                        onClose={() => this.setState({orderModalOpen:false})}
                        product={this.state.product}
                    />

                </div>

            )
    }
}

export function ProductPageParent()
{
    const [product, setProd] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const {id} = useParams();
    useEffect(()=>{
        setLoading(true)
        setError(null)
        axios.get(`/product/${id}`).then(res =>{
            if(res.status < 300)
            {
                setProd(res.data)
            }
            setLoading(false)
        }).catch(e => {
            setError('Не удалось загрузить товар')
            setLoading(false)
        })
    },[id])
    if (loading) return (
        <div className="container mt-5">
            <div className="skeleton" style={{height:40, marginBottom:20, maxWidth:400}} />
            <div className="d-flex gap-4">
                <div className="skeleton" style={{width:'35vw', height:'50vh'}} />
                <div className="flex-grow-1">
                    <div className="skeleton" style={{height:20, marginBottom:10}} />
                    <div className="skeleton" style={{height:20, marginBottom:10}} />
                    <div className="skeleton" style={{height:20, marginBottom:10, width:'60%'}} />
                </div>
                <div className="skeleton" style={{width:300, height:200}} />
            </div>
        </div>
    )
    if (error) return <p className="text-center text-muted mt-5">{error}</p>
    if(product != null)
        return (<ProductPage product = {product}/>)
    return null
}